<template>
    <div id="chatbot">
		<div class="container mt-3">
            
			<ul class="nav nav-tabs hidden-xs" style="padding-top:15px;">
				<li class="nav-item" :class="{'active' : currentView == 'chatbot'}">
					<a class="nav-link" href="javascript:void(0);" @click="currentView = 'chatbot'"><i class="fas fa-wrench"></i> Chatbot Menu</a>
				</li>
				<li class="nav-item" :class="{'active' : currentView == 'conversation'}" >
					<a class="nav-link" href="javascript:void(0);" @click="currentView = 'conversation'"><i class="fas fa-comment"></i> Conversation</a>
				</li>
                <li class="nav-item" :class="{'active' : currentView == 'training'}" >
					<a class="nav-link" href="javascript:void(0);" @click="currentView = 'training'"><i class="fas fa-chalkboard-teacher"></i> Training</a>
				</li>
                <li class="nav-item" :class="{'active' : currentView == 'broadcast'}" >
					<a class="nav-link" href="javascript:void(0);" @click="currentView = 'broadcast'"><i class="fas fa-bullhorn"></i> Broadcast</a>
				</li>
                <!-- <li class="nav-item" :class="{'active' : currentView == 'livechat'}">
					<a class="nav-link" href="javascript:void(0);" @click="currentView = 'livechat'"><i class="fas fa-comments"></i> livechat <v-premium-lock :inline="true"></v-premium-lock></a>
				</li> -->                
			</ul>

            
            <cool-select
                v-model="currentView"
                :items="viewOption"
                item-value="value"
                item-text="title"
                style="padding-bottom: 15px;position: relative;border-bottom: 1px solid #eee"
                @focus="isViewOptionFocus = true"
                @blur="isViewOptionFocus = false"
                class="visible-xs"
            >
                <template
                slot="item"
                slot-scope="{ item: view }"
                >
                <div style="display: flex; align-items: center;">
                    <i :class="view.icon"></i> 

                    <div style="margin-left: 5px;">
                     {{ view.title }}
                    </div>
                </div>
                </template>

                <template
                slot="selection"
                slot-scope="{ item: view }"
                >
                <div style="display: flex; align-items: center;">
                    <i :class="view.icon"></i> 

                    <div style="margin-left: 5px;">
                     {{ view.title }}
                    </div>

                    <i class="fas" :class="{'fa-chevron-down' : isViewOptionFocus , 'fa-chevron-up' : !isViewOptionFocus}"  style="position: absolute; right: 10px"></i>
                </div>
                </template>
            </cool-select>

				
                <template v-if="currentView == 'chatbot'">
                    <div class="tab-container">
                    <br>
                    <div class="container-fluid">
                        <div class="setting-container">
							<welcome-message></welcome-message>
						</div>

                    </div>
                    </div>
                </template>
                <template v-else-if="currentView == 'conversation'">
                    <div class="tab-container">
                    <br>
					<intent></intent>
                    </div>
                </template>
                <template v-else-if="currentView == 'training'">
                    <div class="tab-container">
                    <br>
                    <training></training>
                    </div>
                </template>
				<template v-else-if="currentView == 'broadcast'">
                    <div class="tab-container">
                    <br>
                    <broadcast></broadcast>
                    </div>
				</template>
                <template v-else-if="currentView == 'livechat'">
                    <div class="tab-container" style="padding-bottom: 0px">
                    <livechat></livechat></div>
				</template>
		</div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
import config from '@/config'
import api from '@/api'
import { CoolSelect } from 'vue-cool-select'

import Intent from '@/components/view/intent/Intent'
import Training from '@/components/view/intent/Training'
import Broadcast from '@/components/view/broadcast/broadcast'
// import Broadcast from '@/components/view/broadcast/messenger'
import Livechat from '@/components/view/livechat/Livechat'
import WelcomeMessage from '@/components/view/setting/WelcomeMessage'
import QuickReply from '@/components/view/chatbot/QuickReply'
    export default {
        data: function(){
            return {
                isViewOptionFocus: false,
                viewOption: [
                    {
                        value: 'chatbot',
                        title: 'Chatbot Menu',
                        icon: 'fas fa-wrench'
                    },
                    {
                        value: 'conversation',
                        title: 'Conversation',
                        icon: 'fas fa-comment'
                    },
                    {
                        value: 'training',
                        title: 'Training',
                        icon: 'fas fa-chalkboard-teacher'
                    },
                    {
                        value: 'broadcast',
                        title: 'Broadcast',
                        icon: 'fas fa-bullhorn'
                    },
                ],
                currentView : 'chatbot',
                env: process.env.NODE_ENV
            }
        },
        components: {
            Broadcast,
            Intent,
            WelcomeMessage,
            QuickReply,
            Training,
            Livechat,
            CoolSelect
        },
        created: function(){
            let vm = this
            if (vm.$route.query.tab) {
                switch(vm.$route.query.tab) {
                    case 'chatbot':
                    case 'conversation':
                    case 'training':
                    case 'broadcast':
                    case 'livechat':
                        vm.currentView = vm.$route.query.tab;
                        break;
                    default:
                        vm.currentView = 'chatbot';
                        break;
                }

            } else {
                vm.currentView = 'chatbot';
            }

        },
        computed: {

            pageid: function(){
                if (!this.$store.state.selectedBot) {
                    return null
                }
                return this.$store.state.selectedBot.pageid
            },
        },
        methods: {
            updateRoute: function() {
                var url = {
                    name: 'chatbot',
                    path: '/chatbot', 
                    query: { 
                        tab: this.currentView
                    }
                }
                if (this.$route.query.datefrom) {
                    url.query.datefrom = this.$route.query.datefrom
                }
                if (this.$route.query.dateto) {
                    url.query.dateto = this.$route.query.dateto
                }
                if (this.currentView == 'livechat' && this.$route.query.user) {
                    url.query.user = this.$route.query.user
                }
                this.$router.push(url)
                this.routeValue = JSON.stringify(this.$route.query)
            }
        },
        watch: {

            currentView: function(){
                this.updateRoute()
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/chatbot/Chatbot.vue